if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Create error modal on initialization
        this.createErrorModal();

        if (localStorage.getItem("uniqueEventShare")) {
          const lsJson = JSON.parse(localStorage.getItem("uniqueEventShare"));
          console.log('lsJson ', lsJson);
          let allCollectionIds = this.form.querySelector('[name="properties[_collection_id]"]').value;
          if (allCollectionIds) {
            allCollectionIds.split(',').forEach((collectionId) => {
              console.log('collectionId ', collectionId);
              const foundObject = lsJson.find(item => item.event.some(event => event.collectionId === collectionId));
              if (foundObject) {
                console.log('foundObject ', foundObject);
                let volunteerId = foundObject.vol;
                var newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = 'properties[_volunteer_id]';
                newInput.value = volunteerId;
                this.form.appendChild(newInput);
                var eventIdInput = document.createElement('input');
                eventIdInput.type = 'hidden';
                eventIdInput.name = 'properties[_event_uuid_id]';
                eventIdInput.value = foundObject?.event[0]?.eventId;
                this.form.appendChild(eventIdInput);
              }
            });
          }
        }
      }

      createErrorModal() {
        // Check if modal already exists
        if (document.getElementById('storeErrorModal')) return;

        // Create modal HTML
        const modalHTML = `
          <div id="storeErrorModal" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999; justify-content: center; align-items: center;">
            <div style="background: white; border-radius: 16px; padding: 40px 30px 30px; max-width: 400px; width: 90%; text-align: center; box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2); animation: modalSlideIn 0.3s ease-out;">
              <div style="width: 80px; height: 80px; margin: 0 auto 20px;">
                <div style="width: 80px; height: 80px; border: 4px solid #dc3545; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                  <div style="position: relative; width: 60px; height: 60px;">
                    <svg height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 508 508" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle style="fill:#e8443a;" cx="254" cy="254" r="254"></circle> <path style="fill:#024730;" d="M435.2,342.4L273.6,62c-8.8-15.2-30.4-15.2-39.2,0L72.8,342.4c-8.8,15.2,2,34,19.6,34h323.2 C433.2,376.4,444,357.6,435.2,342.4z"></path> <path style="fill:#FFD05B;" d="M92.4,356c-0.4,0-1.2,0-2-1.2s0-2,0-2L252,72.4c0-0.4,0.8-1.2,2-1.2c1.2,0,1.6,0.8,2,1.2l161.6,280.4 c0,0.4,0.8,1.2,0,2c-0.8,1.2-1.6,1.2-2,1.2H92.4z"></path> <g> <path style="fill:#024730;" d="M275.6,197.2c0,36-9.6,84.4-21.6,84.4s-21.6-48.4-21.6-84.4s9.6-46.4,21.6-46.4 S275.6,161.2,275.6,197.2z"></path> <circle style="fill:#024730;" cx="254" cy="314" r="18"></circle> </g> </g></svg>
                  </div>
                </div>
              </div>
              <h2 style="font-size: 24px; font-weight: 600; color: #dc3545; margin-bottom: 15px;">Invalid Store!</h2>
              <p style="font-size: 16px; color: #333; line-height: 1.5; margin-bottom: 25px;">Purchases are not supported here. Please visit the store to buy this item.</p>
              <button id="storeErrorModalBtn" style="background: #dc3545; color: white; border: none; padding: 12px 40px; font-size: 16px; font-weight: 500; border-radius: 6px; cursor: pointer; transition: background 0.2s;">Ok</button>
            </div>
          </div>
        `;

        // Add CSS animation
        const style = document.createElement('style');
        style.textContent = `
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          #storeErrorModalBtn:hover {
            background: #c82333 !important;
          }
          #storeErrorModalBtn:active {
            transform: scale(0.98);
          }
        `;
        document.head.appendChild(style);

        // Append modal to body
        document.body.insertAdjacentHTML('beforeend', modalHTML);

        // Get modal elements
        const modal = document.getElementById('storeErrorModal');
        const okBtn = document.getElementById('storeErrorModalBtn');

        // Close modal on OK button click
        okBtn.addEventListener('click', () => {
          modal.style.display = 'none';
        });

        // Close modal on outside click
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.style.display = 'none';
          }
        });

        // Close modal on ESC key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.style.display === 'flex') {
            modal.style.display = 'none';
          }
        });
      }

      showErrorModal() {
        const modal = document.getElementById('storeErrorModal');
        if (modal) {
          modal.style.display = 'flex';
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Validate store code
        const storeCodeInput = this.form.querySelector('[name="properties[_store_code]"]');
        const storeCodeValue = storeCodeInput ? storeCodeInput.value.trim() : '';
        
        if (!storeCodeValue) {
          this.showErrorModal();
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}